import {
  UNIVERSITY_LIST_REQ,
  UNIVERSITY_LIST_SUCCESS,
  UNIVERSITY_LIST_FAILED,
  UPDATE_UNIVERSITY_FAILED,
  UPDATE_UNIVERSITY_SUCCESS,
  UPDATE_UNIVERSITY_RESET,
  DELETE_UNIVERSITY_REQ,
  DELETE_UNIVERSITY_FAILED,
  DELETE_UNIVERSITY_SUCCESS,
  DELETE_UNIVERSITY_RESET,
  CREATE_UNIVERSITY_FAILED,
  CREATE_UNIVERSITY_REQ,
  CREATE_UNIVERSITY_SUCCESS,
  CREATE_UNIVERSITY_RESET,
  UPDATE_UNIVERSITY_REQ,
  UNIVERSITY_LIST_RESET,
  UNIVERSITY_SINGLE_DATA_REQ,
  UNIVERSITY_SINGLE_DATA_SUCCESS,
  UNIVERSITY_SINGLE_DATA_FAILED,
  UNIVERSITY_SINGLE_DATA_RESET,
} from "../Constants/universityConstants";

export const UNIVERSITY_LIST_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case UNIVERSITY_LIST_REQ: {
      return { university_list_Loading: true, university_list_Error: false };
    }
    case UNIVERSITY_LIST_SUCCESS: {
      return { university_list_Loading: false, UniversityList: payload };
    }

    case UNIVERSITY_LIST_FAILED: {
      return { university_list_Loading: false, university_list_Error: payload };
    }

    case UNIVERSITY_LIST_RESET: {
      return {};
    }

    default:
      return state;
  }
};

export const UNIVERSITY_SINGLE_DATA_REDUCER = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case UNIVERSITY_SINGLE_DATA_REQ: {
      return { University_Single_Data_Loading: true };
    }
    case UNIVERSITY_SINGLE_DATA_SUCCESS: {
      return {
        University_Single_Data_Loading: false,
        University_Single_Data: payload,
      };
    }

    case UNIVERSITY_SINGLE_DATA_FAILED: {
      return {
        University_Single_Data_Loading: false,
        University_Single_Data_Error: payload,
      };
    }
    case UNIVERSITY_SINGLE_DATA_RESET: {
      return {};
    }

    default:
      return state;
  }
};

export const UNIVERSITY_LIST_CREATE_REDUCER = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case CREATE_UNIVERSITY_REQ: {
      return { Create_University_Loading: true };
    }
    case CREATE_UNIVERSITY_SUCCESS: {
      return {
        Create_University_Loading: false,
        Create_University_Success: payload,
      };
    }

    case CREATE_UNIVERSITY_FAILED: {
      return {
        Create_University_Loading: false,
        Create_University_Error: payload,
      };
    }

    case CREATE_UNIVERSITY_RESET: {
      return {};
    }

    default:
      return state;
  }
};

export const UNIVERSITY_LIST_UPDATE_REDUCER = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case UPDATE_UNIVERSITY_REQ: {
      return { Update_University_Loading: true };
    }

    case UPDATE_UNIVERSITY_SUCCESS: {
      return {
        Update_University_Loading: false,
        Update_University_Success: payload,
      };
    }

    case UPDATE_UNIVERSITY_FAILED: {
      return {
        Update_University_Loading: false,
        Update_University_Error: payload,
      };
    }

    case UPDATE_UNIVERSITY_RESET: {
      return {};
    }

    default:
      return state;
  }
};

export const UNIVERSITY_DELETE_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case DELETE_UNIVERSITY_REQ: {
      return { Delete_University_Loading: true };
    }

    case DELETE_UNIVERSITY_SUCCESS: {
      return {
        Delete_University_Loading: false,
        Delete_University_Success: payload,
      };
    }

    case DELETE_UNIVERSITY_FAILED: {
      return {
        Delete_University_Loading: false,
        Delete_University_Error: payload,
      };
    }

    case DELETE_UNIVERSITY_RESET: {
      return {};
    }

    default:
      return state;
  }
};
